import fetchRequest from '../util/fetch'
import errUtil from '../util/error'

const query = `mutation PositionDeleteMutation (
  $workspace: ID!,
  $id: ID!
) {
  positionDelete (
    workspace: $workspace
    id: $id
  ) {
    id
  }
}`

async function requestPositionDelete (variables, token) {
  const response = await fetchRequest({
    variables,
    query,
    token
  })
  if (!response) return errUtil.noResponse()

  const { errors, data } = response
  if (errors) {
    return errUtil.apiError('position-delete', errors)
  }
  return data.positionDelete
}

export default requestPositionDelete
